// Where a form's photos and signature come from, and go to.
//
// The read-back, the versions page and a submitted record draw their files
// straight from the server. The fill page does not (round 42): a photo taken
// in a dead spot lives on the phone until it can upload, so the page hands
// the renderer a source that answers from the phone first. One seam, so
// FormFieldInput stays the one place a photo question is drawn.
import { formFill, uploadSubmissionFile } from '../../formsApi';

export interface FormFileSource {
  /** Something an <img> can show, synchronously. */
  url(fileId: string): string;
  /** Adds a file to the form and answers with its id. */
  upload(
    fieldKey: string,
    kind: 'photo' | 'signature',
    file: Blob,
    filename: string
  ): Promise<{ id: string }>;
  /** Takes a file off a draft. */
  remove(fileId: string): Promise<void>;
}

/** Straight to and from the server: every screen except the fill page. */
export function serverFileSource(submissionId: string): FormFileSource {
  return {
    url: (fileId) => formFill.fileUrl(fileId),
    upload: (fieldKey, kind, file, filename) =>
      uploadSubmissionFile(submissionId, fieldKey, kind, file, filename),
    remove: (fileId) => formFill.deleteFile(submissionId, fileId),
  };
}
